import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface FormModalProps {
  open: boolean;
  handleClose: () => void;
  formUrl: string;
}

/**
 * A reusable modal component to display an embedded Google Form.
 * @param {object} props - The component props.
 * @param {boolean} props.open - Controls the visibility of the modal.
 * @param {function} props.handleClose - Callback function to close the modal.
 * @param {string} props.formUrl - The URL of the Google Form to embed.
 */
const FormModal: React.FC<FormModalProps> = ({
  open,
  handleClose,
  formUrl,
}) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="form-modal-title"
      aria-describedby="form-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "95%", md: "80%" },
          height: { xs: "90%", md: "90%" },
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          p: 2,
          outline: "none",
        }}
      >
        {/* Close button at the top right of the modal */}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
        {/* The iframe embedding the Google Form */}
        <Box sx={{ flexGrow: 1 }}>
          <iframe
            src={formUrl}
            width="100%"
            height="100%"
            frameBorder="0"
            title="Embedded Google Form"
            style={{ borderRadius: "8px", margin: 0 }}
          >
            Loading…
          </iframe>
        </Box>
      </Box>
    </Modal>
  );
};

export default FormModal;
